/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingInfoField
 */
export interface BookingInfoField {
    /**
     * Human-readable field name (e.g. "Given Name", "Cancellation Policy").
     * @type {string}
     * @memberof BookingInfoField
     */
    label: string;
    /**
     * The field value as display text; null when absent.
     * @type {string}
     * @memberof BookingInfoField
     */
    value?: string | null;
}

/**
 * Check if a given object implements the BookingInfoField interface.
 */
export function instanceOfBookingInfoField(value: object): value is BookingInfoField {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function BookingInfoFieldFromJSON(json: any): BookingInfoField {
    return BookingInfoFieldFromJSONTyped(json, false);
}

export function BookingInfoFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingInfoField {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function BookingInfoFieldToJSON(json: any): BookingInfoField {
    return BookingInfoFieldToJSONTyped(json, false);
}

export function BookingInfoFieldToJSONTyped(value?: BookingInfoField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'value': value['value'],
    };
}

